export default __webpack_public_path__ + "static/alfred_search_cp_result-f19a4c2072c090f09df0c1a912bd3807.png";